import { createI18n } from "vue-i18n";
import { pt } from "./locale/pt";
import { zh } from "./locale/zh";
import { en } from "./locale/en";
import { getI18nList } from "@/api/common";
import { showToast } from "vant";
// import api from '../common/js/request'
// import store from "../store";

const messages = {
  pt: {
    ...pt
  },
  zh: {
    ...zh
  },
  en: {
    ...en
  }
};

const langLoaded = false;

const i18n = createI18n({
  locale: "pt",
  fallbackLocale: "pt",
  messages
});

const loadLanguage = async (lang:any) => {
  getI18nList({ languageCode: lang }).then(res => {
    i18n.global.setLocaleMessage(lang, res.data);
    // i18n.global.setLocaleMessage('en', messages.en);
    i18n.global.locale = lang;
    localStorage.setItem("lang", lang);
  }).catch(err => {
    // showToast(err)
    i18n.global.setLocaleMessage('pt', messages.pt); 
    i18n.global.locale = 'pt';
    localStorage.setItem("lang", 'pt');
  })
};

const init = async () => {
  const lang = localStorage.getItem("lang") || "pt";
  await loadLanguage(lang);
}

export { i18n, langLoaded, loadLanguage, init };
